export const rootPaths = {
  INDEX: '/',
  PRIVACY_POLICY: '/privacy-policy'
}